import { dom } from "@fortawesome/fontawesome-svg-core";
import { setAvatar, text } from "./dialog-card";

/**
 * Read-more on a reference card opens the full text in a shared dialog instead
 * of expanding inline. The single dialog element is reused for every card and
 * populated on open; closing/backdrop handling is wired globally by
 * initDialogs().
 */

export const openReferenceDialog = (card: HTMLElement) => {
  const dialog = document.getElementById("dialog-reference") as HTMLDialogElement | null;
  if (!dialog) {
    return;
  }

  setAvatar(dialog.querySelector(".dialog-reference-avatar"), card);

  // Name links through to the referencer's profile; the stretched-link makes
  // the whole (position-relative) header clickable, matching the review dialog.
  const nameSlot = dialog.querySelector(".dialog-reference-name");
  if (nameSlot) {
    const authorEl = card.querySelector(".author");
    const authorName = text(authorEl);
    const authorLink = authorEl?.closest("a") as HTMLAnchorElement | null;
    const profileUrl = authorLink?.getAttribute("href") ? authorLink.href : null;
    if (profileUrl) {
      const link = document.createElement("a");
      link.href = profileUrl;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.className = "text-reset text-decoration-none stretched-link";
      link.textContent = authorName;
      nameSlot.replaceChildren(link);
    } else {
      nameSlot.textContent = authorName;
    }
  }

  const relationshipSlot = dialog.querySelector(".dialog-reference-relationship");
  if (relationshipSlot) {
    relationshipSlot.textContent = text(card.querySelector(".title .text-gray-600 small"));
  }

  const contentSlot = dialog.querySelector(".dialog-reference-content");
  const description = card.querySelector(".review-description");
  if (contentSlot) {
    contentSlot.textContent = description?.getAttribute("data-content") ?? text(description);
  }

  const dateSlot = dialog.querySelector(".dialog-reference-date");
  if (dateSlot) {
    dateSlot.textContent = text(card.querySelector(".card-body > .text-gray-600 small"));
  }

  dom.i2svg();

  if (!dialog.open) {
    dialog.showModal();
  }
};
